import React, { ReactNode } from 'react';

interface IProps {
  isUploading: boolean;
  children: ReactNode;
}

export const UploadingOverlay = ({ isUploading = false, ...rest }: IProps) => (
  <div
    className={`absolute top-0 left-0 flex size-full flex-col items-center justify-center rounded-xl text-base transition-all ${
      isUploading ? 'opacity-100' : 'opacity-0'
    }`}
    style={
      isUploading
        ? { zIndex: 'auto', backgroundColor: `rgba(255, 255, 255, 0.8)` }
        : { zIndex: -1, backgroundColor: `rgba(255, 255, 255, 0.8)` }
    }
    {...rest}
  />
);
